import { useNavigate } from "react-router";

export default function PagingItem({isactive, iscurrent, text, href}){
  const nagivate = useNavigate();
  
  let style = iscurrent? 'bg-black text-white':'bg-gray-100 text-black';
  if(!isactive) style='bg-gray-200 text-white'

  const handleClick = ()=>{
    if(isactive) nagivate(href);
  }
  return (
    <div onClick={()=>handleClick()} 
      className={`mx-1 flex items-center justify-center rounded w-8 h-8 ${style}`}>
        {text}
    </div>
  );
}